/* @flow */
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import './styles/ImageWrapper.scss';

/**
 * ## Wraps figures that have different heights in order to retain subsequent content alignment.
 *
 *
 * ```example
 * <div style={{ display: 'flex' }}>
 *   <div style={{ background: '#17a687' }}>
 *     <ImageWrapper size="xsmall">
 *       <Glyph
 *         name="remind-icon"
 *         size="xxxlarge"
 *       />
 *     </ImageWrapper>
 *   </div>
 *   <div style={{ background: '#5fc4bb' }}>
 *     <ImageWrapper size="xsmall">
 *       <Glyph
 *         name="remind-icon"
 *         size="xlarge"
 *       />
 *     </ImageWrapper>
 *   </div>
 * </div>
 * ```
 *
 *
 * # TODO
 * * Add default centering
 */

class ImageWrapper extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    shape: PropTypes.oneOf(['circle']),
    size: PropTypes.oneOf(['small', 'xsmall']),
  };

  static propClasses = {
    shape: {
      circle: 'ImageWrapper--circle',
    },
    size: {
      small: 'ImageWrapper--small',
      xsmall: 'ImageWrapper--xsmall',
    },
  };

  render() {
    const { children, className } = this.props;

    return (
      <div className={cx('ImageWrapper', getPropClassesFromInstance(this), className)}>
        {children}
      </div>
    );
  }
}

export default ImageWrapper;
